import {createApp} from 'vue';
import i18n from "@/plugins/i18n";
import '@/plugins/RecaptchaStore';
import {CustomerOrders} from '@webstacz/shop-components';
import '@/plugins/Sentry';

const token: HTMLMetaElement | null = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.csrfToken = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

window.onload = () => {
    const el = document.querySelector('.order-status-form') as HTMLElement;
    if (el) {
        const app = createApp(CustomerOrders, {
            params: {
                url: el.getAttribute('data-url'),
            },
        });

        app.use(i18n);
        app.mount(el);
    }
};
